import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import {label3} from "@irati/ui/src/Labels/css/labels"
import padding from "@irati/ui/src/global/padding"

export default styled.th`

  &&&{
    border-bottom: none;
    white-space: nowrap;
    ${label3};
    color: ${greys.medium};
    text-transform: uppercase;
    padding-right: ${padding.medium};

    ${({right}) => right && `
      text-align: right;
    `}

    ${({flush}) => flush && `
      padding-right: 10px;
    `}
  }
`
